import { NgIf } from '@angular/common';
import { Component, DestroyRef, Input, OnDestroy, OnInit, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { RcpFavLogoutWidgetComponent, RpFavWidgetComponent } from '@casinocore/platform';
import { CasinoLobbyService, CasinoManager, ConfigProviderService } from '@casinocore/platform/core';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cs-rp-fav-section',
    templateUrl: 'rp-fav-section.component.html',
    imports: [NgIf, RpFavWidgetComponent, RcpFavLogoutWidgetComponent],
})
export class RPFavSectionComponent implements OnInit, OnDestroy {
    @Input() lobbyType: string;
    isLobbyLoaded: boolean;
    lobbyLoadSubscription: Subscription;
    isAbRecentlyPlayedWidget: boolean;
    IsRpFavWidgetEnabled: boolean;
    recentObs: Subscription;
    isAbRecentlyPlayedContainer: boolean;
    cozyUserSubscriber: Subscription;
    private destroyRef = inject(DestroyRef);
    constructor(
        private casinoLobbyService: CasinoLobbyService,
        private configProviderService: ConfigProviderService,
        private casinoManager: CasinoManager,
    ) {}

    ngOnInit() {
        const abTestingConfig: any = this.configProviderService.provideABTestingConfig();
        this.isAbRecentlyPlayedWidget = abTestingConfig.isEnabled && abTestingConfig.recentlyPlayedAsWidget;
        this.isAbRecentlyPlayedContainer = abTestingConfig.isEnabled && abTestingConfig.recentlyPlayedAsContainer;
        const rpWidgetConfig: any = this.configProviderService.providewidgetConfig();
        this.lobbyLoadSubscription = this.casinoLobbyService.lobbyLoadedObservable.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((response) => {
            if (response) {
                this.isLobbyLoaded = true;
            }
        });
        this.IsRpFavWidgetEnabled = this.casinoManager.IsFeatureEnabledforLobbytype(this.lobbyType, rpWidgetConfig.isRpFavWidgetEnabled);
    }
    ngOnDestroy() {
        if (this.lobbyLoadSubscription) {
            this.lobbyLoadSubscription.unsubscribe();
        }
        if (this.cozyUserSubscriber) {
            this.cozyUserSubscriber.unsubscribe();
        }
    }
}
